// ABOUTME: Displays the shareable link status with toggle, status icon, and text.
// ABOUTME: Combines ToggleButton with enabled/disabled status indicators.
import { when } from '@execonline-inc/maybe-adapter';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/20/solid';
import { observer } from 'mobx-react';
import ToggleButton from '../../../../../../../../../ToggleButton';
import { T, TranslationsContext, translation } from '../../../../../../../../../../Translations';

interface Props {
  isActive: boolean;
  onToggle: () => void;
  programName: string;
}

function ShareableLinkStatus({ isActive, onToggle, programName }: Props) {
  return (
    <div className="flex items-center gap-3">
      <TranslationsContext.Consumer>
        {(ts) => (
          <ToggleButton
            value={isActive}
            handleOnClick={onToggle}
            intercomTarget="shareable-link-toggle"
            ariaLabel={`${translation('Shareable Link')(ts)}: ${programName}`}
          />
        )}
      </TranslationsContext.Consumer>
      {when(isActive, {})
        .map(() => (
          <div className="flex items-center gap-2">
            <CheckCircleIcon className="h-5 w-5 text-accent" />
            <div className="flex flex-col">
              <span className="text-sm font-medium text-foreground">
                <T kind="Enabled" />
              </span>
              <span className="text-xs text-muted-foreground">
                <T kind="Link active" />
              </span>
            </div>
          </div>
        ))
        .getOrElse(() => (
          <div className="flex items-center gap-2">
            <XCircleIcon className="h-5 w-5 text-muted-foreground" />
            <div className="flex flex-col">
              <span className="text-sm font-medium text-muted-foreground">
                <T kind="Disabled" />
              </span>
              <span className="text-xs text-muted-foreground">
                <T kind="Link inactive" />
              </span>
            </div>
          </div>
        ))}
    </div>
  );
}

export default observer(ShareableLinkStatus);
